import React from 'react';
import { Button } from '../../components';
import classes from './imagesResults.module.css';
import ImageResultItem from './imageResultitem';

var ImagesResults = function ImagesResults(_ref) {
  var _imagesData$items$;

  var imagesData = _ref.imagesData;
  return React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    className: "text-center"
  }, React.createElement("h6", {
    className: "text-black leading-160"
  }, "Full Library Access"), React.createElement("p", {
    className: "text-bronze mt-1.5 mb-10 leading-171"
  }, "Updating your website and wish to download all of our image assets? We make it easy for you! Just click on the button below for access."), React.createElement("a", {
    href: "https://media.hubbardtonforge.com",
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Button, {
    size: "large",
    priority: "normal",
    "aria-label": "Access our full library"
  }, "ACCESS OUR FULL LIBRARY"))), React.createElement("div", {
    className: "flex justify-between border-b border-solid border-bronze pt-10"
  }, React.createElement("h6", {
    className: "mb-4 text-black font-bold"
  }, "Search Results")), React.createElement("div", {
    className: "grid grid-cols-9  border-b border-solid border-gray py-3"
  }, React.createElement("div", {
    className: "col-span-7"
  }, " File name "), React.createElement("div", {
    className: "col-span-1 sm_col-span-1 sm_text-center"
  }, " Size "), React.createElement("div", {
    className: "col-span-1 sm_col-span-1 sm_text-center"
  }, " Type ")), imagesData === null || imagesData === void 0 ? void 0 : (_imagesData$items$ = imagesData.items[0]) === null || _imagesData$items$ === void 0 ? void 0 : _imagesData$items$.media_gallery_entries.map(function (item, idx) {
    var _imagesData$items$2;

    return React.createElement(ImageResultItem, {
      key: idx,
      item: item,
      name: imagesData === null || imagesData === void 0 ? void 0 : (_imagesData$items$2 = imagesData.items[0]) === null || _imagesData$items$2 === void 0 ? void 0 : _imagesData$items$2.name
    });
  }));
};

export default ImagesResults;